$(document).ready(function(){
$('.viewfour').hide();
  $(".view2").click(function(){
//alert('hello');
$('.viewtwo').show();
$('.viewfour').hide();
$('.grid').addClass('nc-grid');
       $('.grid__item').removeClass('medium-up--one-quarter');
      $('.grid__item').addClass('medium-up--one-whole');
    $('.grid').removeClass('four-grid-data');
  });

  $(".view4").click(function(){
//alert('hello2');
$('.viewtwo').hide();
$('.viewfour').show();
$('.grid').removeClass('nc-grid');
    $('.grid').addClass('four-grid-data');
  $('.grid__item').removeClass('medium-up--one-whole');
      $('.grid__item').addClass('medium-up--one-quarter'); 
 });

$(".sdata").click(function(){

if($(this).next().is(':visible')){
 $(this).next().hide('1000');
   
}
  else
  {
    $(this).next().show('1000');
  }
});

    $(window).scroll(function(){ 
        if ($(this).scrollTop() > 100) { 
            $('#scroll').fadeIn(); 
        } else { 
            $('#scroll').fadeOut(); 
        } 
    }); 
    $('#scroll').click(function(){ 
        $("html, body").animate({ scrollTop: 0 }, 600); 
        return false; 
    }); 


   if ($(window).width() < 768) {
     $('.cslider').slick({
      slidesToShow: 1.8,
    slidesToScroll: 1,
    adaptiveHeight: true,
    infinite: true,
    arrows: true,
    dots: false
 
   
     });
    }
    




 jQuery(window).scroll(function() {  

 if ($(window).width() > 1100) {

  if($(window).scrollTop() + $(window).height() > $(document).height() - 450) {
   jQuery(".nc-filters").removeClass("stickydiv");
  }
  else
  {
    jQuery(".nc-filters").addClass("stickydiv");  

  }
  
 }
});


$('.togglemenu').click(function(e) {
  	e.preventDefault();
  
    let $this = $(this);
  
    if ($this.next().hasClass('show')) {
        $this.next().removeClass('show');
        $this.next().slideUp(350);
        $this.addClass('showmenu');
    } else {
        $this.parent().parent().find('li .inner').removeClass('show');
        $this.parent().parent().find('li .inner').slideUp(350);
        $this.next().toggleClass('show');
        $this.removeClass('showmenu');
        $this.next().slideToggle(350);
    }
});

$('.sdata').click(function(e) {
   $(this).toggleClass('sshow');
});



$(".collection-filter__inner").each(function(){
    if ($(this).is(':empty')) { 
         $(this).parent().remove();
} 
});
  
  
  
$(".crosspopup").click(function(){
$('.product-modal-open').css('display','none');
 window.history.go(-1);

});



 if ($(window).width() < 768) {
$(window).scroll(function() {    
    var scroll = $(window).scrollTop();

     //>=, not <=
    if (scroll >= 50)
   {
        //clearHeader, not clearheader - caps H
        $(".site-header").addClass("site-header--sticky site-header--opening");
        $(".site-header").parent().addClass('header-wrapper--sticky');
    }
    else
    {
         $(".site-header").removeClass("site-header--sticky site-header--opening");
        $(".site-header").parent().removeClass('header-wrapper--sticky');
    }
}); 
 }






// $(".collapsible-trigger").click(function(){


//  if($(this).attr('aria-expanded') == 'true')
//    {
           
//           $(this).parent().find('.ncbtn.text-link.tags-toggle').hide();
//           $(this).parent().find('ul.tag-list').removeClass('is-open');
//           $(this).parent().find('.ncbtn.text-link.tags-toggle').attr('class','collapsible-trigger collapsible--auto-height collapsible-trigger-btn ncbtn text-link tags-toggle');
// $(this).parent().find('.collapsible-content ').attr('class','collapsible-content collapsible-content--all');

//    }
//    else
//    {
 
      
// $(this).parent().find('.ncbtn.text-link.tags-toggle').show(); 
//   }



  
// });

});

var modal = document.getElementById("myModal");

// Get the button that opens the modal
var btn = document.getElementById("myBtn");

// Get the <span> element that closes the modal
var span = document.getElementsByClassName("close")[0];

// When the user clicks the button, open the modal 
btn.onclick = function() {
  modal.style.display = "block";
 $('#myModal .modal-content').addClass('ac1');
}

// When the user clicks on <span> (x), close the modal
span.onclick = function() {
  modal.style.display = "none";
$('#myModal .modal-content').removeClass('ac1');
}

// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
  if (event.target == modal) {
    modal.style.display = "none";
  }
}

var modal2 = document.getElementById("myModal2");

// Get the button that opens the modal
var btn2 = document.getElementById("myBtn2");

// Get the <span> element that closes the modal
var span2 = document.getElementsByClassName("close2")[0];

// When the user clicks the button, open the modal 
btn2.onclick = function() {
  modal2.style.display = "block";
$('#myModal2 .modal-content').addClass('ac2');
}

// When the user clicks on <span> (x), close the modal
span2.onclick = function() {
  modal2.style.display = "none";
$('#myModal2 .modal-content').removeClass('ac2');
}

// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
  if (event.target == modal2) {
    modal2.style.display = "none";
  }
}

        var o = s(n(51));
        t.default = function() {
            var e = document.getElementById("ShopTheLook")
              , t = {}
              , n = null;
            if (e) {
                var s = e.querySelectorAll('[data-block-type="stl-image"]')
                  , u = document.getElementById("ShopTheLookModal");
                s.length > 0 && s.forEach((function(e) {
                    var t = e.querySelectorAll(".stl__popup-trigger")
                      , n = e.querySelectorAll(".stl__popup");
                    t.length && t.forEach((function(e) {
                        e.addEventListener("click", d)
                    }
                    )),
                    n.length && n.forEach((function(e) {
                        e.addEventListener("click", l)
                    }
                    ))
                }
                )),
                u && (n = function(e) {
                    var n = e
                      , a = n.querySelector(".stl-modal__close")
                      , s = null
                      , u = void 0
                      , d = void 0
                      , l = 0;
                    function p(e) {
                        e && e.preventDefault(),
                        s = null,
                        d && d.destroy(),
                        document.body.classList.remove("modal--open"),
                        n.classList.remove("stl-modal--open"),
                        window.scrollTo(0, l)
                    }
                    function y(e) {
                        n.querySelector(".stl-modal__content").innerHTML = e;
                        var t = n.querySelector("[data-product-json]");
                        u = JSON.parse(t.innerHTML),
                        function() {
                            var e = n.querySelectorAll(".swatch-element input");
                            e.length > 0 && e.forEach((function(e) {
                                e.addEventListener("change", (function() {
                                    !function() {
                                        var e = n.querySelector("#product-select")
                                          , t = function() {
                                            var e = u.variants
                                              , t = n.querySelectorAll(".swatch-element input:checked")
                                              , a = [].concat((0,
                                            o.default)(t)).map((function(e) {
                                                return e.value
                                            }
                                            ));
                                            return e.filter((function(e) {
                                                return a.every((function(t, n) {
                                                    return e.options[n] === t
                                                }
                                                ))
                                            }
                                            ))[0] || null
                                        }()
                                          , a = n.querySelector("button.add-to-cart")
                                          , i = a.querySelector("span");
                                        t ? (e.querySelector('option[value="' + t.id + '"').selected = "selected",
                                        t.available ? (i.innerHTML = "BUY NOW",
                                        a.disabled = !1) : (i.innerHTML = "Sold Out",
                                        a.disabled = !0)) : (i.innerHTML = "Unavailable",
                                        a.disabled = !0)
                                    }()
                                }
                                ))
                            }
                            )),
                            (0,
                            i.default)(n).find("form").on("submit", (function(e) {
                                e.preventDefault(),
                                p(),
                                (0,
                                c.addToCart)((0,
                                i.default)(this).serialize(), "product")
                            }
                            ))
                        }(),
                        (d = new r.tns({
                            container: n.querySelector(".product-images__slideshow"),
                            items: 1,
                            controls: !0,
                            prevButton: n.querySelector(".product-images__controls button.prev"),
                            nextButton: n.querySelector(".product-images__controls button.next"),
                            autoHeight: !0,
                            mouseDrag: !0
                        })).events.on("transitionEnd", (function(e) {
                            var t = e.displayIndex;
                            n.querySelector(".product-images__controls span.currslide").textContent = t < 10 ? "0" + t : t
                        }
                        ))
                    }
                    return document.querySelector(".modal-overlay").addEventListener("click", (function(e) {
                        e.target == this && p(e)
                    }
                    )),
                    a.addEventListener("click", p),
                    {
                        open: function(e) {
                            l = window.scrollY,
                            document.body.style.top = "-" + l + "px",
                            n.classList.add("stl-modal--open"),
                            document.body.classList.add("modal--open"),
                            void 0 === t[s = e] ? m(s, (function(e) {
                                y(e)
                            }
                            )) : y(t[s])
                        }
                    }
                }(u)),
                document.addEventListener("click", (function(e) {
                    if (!e.target.classList.contains("stl__popup-trigger")) {
                        var t = document.querySelectorAll(".stl__popup.stl__popup--open");
                        t.length > 0 && t.forEach((function(e) {
                            return e.classList.remove("stl__popup--open")
                        }
                        ))
                    }
                }
                ))
            }
            function d(e) {
                var t = this.parentNode
                  , n = t.dataset.product
                  , o = t.querySelector(".stl__popup")
                  , a = document.querySelectorAll(".stl__popup.stl__popup--open");
                a.length > 0 && a.forEach((function(e) {
                    return e.classList.remove("stl__popup--open")
                }
                )),
                n && !o.classList.contains("stl__popup--open") && m(n),
                o.classList.toggle("stl__popup--open")
            }
            function l(e) {
                e.preventDefault();
                var t = this.dataset.product;
                t && n.open(t)
            }
            function m(e, n) {
                if (t.hasOwnProperty(e))
                    return void 0 !== n && "function" == typeof n ? n(res.data) : void 0;
                a.default.get("/products/" + e + "?view=form").then((function(o) {
                    return t[e] = o.data,
                    void 0 !== n && "function" == typeof n && n(o.data),
                    o
                }
                )).catch((function(e) {
                    console.log(e)
                }
                ))
            }
        }
        ;
        var a = s(n(160))
          , i = s(n(0))
          , r = n(201)
          , c = n(6);
        function s(e) {
            return e && e.__esModule ? e : {
                default: e
            }
        }
    

    